import React, { forwardRef } from "react";
import { QRCodeSVG } from "qrcode.react";

/*
 * Label QR palet untuk Xprinter XP-TT426B, kertas 50 x 50 mm.
 *
 * - Ukuran memakai mm (bukan px) supaya hasil cetak sama persis dengan kertas.
 * - QR memakai SVG supaya tetap tajam di printer thermal 203 dpi.
 * - Memakai named page "palet50" supaya tidak tertimpa @page 101x53mm
 *   (ukuran label rak) yang ada di App.css.
 * - Tidak memakai padding/margin karena App.css men-set
 *   `* { margin:0 !important; padding:0 !important }` saat print;
 *   jarak diatur dengan flex `gap` dan ukuran elemen.
 */

const LABEL = 50; // mm
const QR = 37;    // mm

const PrintLabels = forwardRef(({ data }, ref) => {
    return (
        <div ref={ref}>
            <style>{`
                @page palet50 { size: ${LABEL}mm ${LABEL}mm; margin: 0; }
                @media print {
                    html, body { width: ${LABEL}mm; margin: 0; padding: 0; }
                }
            `}</style>

            {data.map((item, i) => (
                <div
                    key={item.id ?? i}
                    style={{
                        page: "palet50",
                        width: `${LABEL}mm`,
                        height: `${LABEL}mm`,
                        boxSizing: "border-box",
                        overflow: "hidden",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "1mm",
                        background: "#fff",
                        color: "#000",
                        fontFamily: "Arial, Helvetica, sans-serif",
                        breakAfter: i === data.length - 1 ? "auto" : "page",
                        pageBreakAfter: i === data.length - 1 ? "auto" : "always",
                        breakInside: "avoid",
                    }}
                >
                    <QRCodeSVG
                        value={String(item.code)}
                        level="M"
                        style={{ width: `${QR}mm`, height: `${QR}mm`, display: "block" }}
                    />

                    <div
                        style={{
                            width: "46mm",
                            textAlign: "center",
                            lineHeight: 1.1,
                        }}
                    >
                        <div
                            style={{
                                fontSize: "13pt",
                                fontWeight: 700,
                                letterSpacing: "0.3mm",
                                whiteSpace: "nowrap",
                            }}
                        >
                            {item.code}
                        </div>
                        {item.bins_name && (
                            <div
                                style={{
                                    fontSize: "8pt",
                                    fontWeight: 600,
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                }}
                            >
                                {item.bins_name}
                            </div>
                        )}
                    </div>
                </div>
            ))}
        </div>
    );
});

export default PrintLabels;
